(() => {
  const COOKIE_NAME = "age_verified";
  const STORAGE_KEY = "age_verified";

  function nowInSeconds() {
    return Math.floor(Date.now() / 1000);
  }

  function readCookie(name) {
    const match = document.cookie.match(new RegExp("(^|;\\s*)" + name.replace(/[.*+?^${}()|[\\]\\\\]/g, "\\$&") + "=([^;]*)"));
    return match ? decodeURIComponent(match[2]) : null;
  }

  function setCookie(name, value, days) {
    const maxAge = Math.max(1, Math.floor(days * 24 * 60 * 60));
    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; Path=/; Max-Age=${maxAge}; SameSite=Lax${secure}`;
  }

  function tryGetLocalStorage(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (_) {
      return null;
    }
  }

  function trySetLocalStorage(key, value) {
    try {
      window.localStorage.setItem(key, value);
      return true;
    } catch (_) {
      return false;
    }
  }

  function isVerified() {
    const cookie = readCookie(COOKIE_NAME);
    if (cookie === "1") return true;

    const ls = tryGetLocalStorage(STORAGE_KEY);
    if (!ls) return false;

    // legacy / defensive: allow simple "1"
    if (ls === "1") return true;

    try {
      const parsed = JSON.parse(ls);
      if (!parsed || parsed.v !== 1) return false;
      if (!parsed.exp) return true;
      return parsed.exp > nowInSeconds();
    } catch (_) {
      return false;
    }
  }

  function lockScroll() {
    document.documentElement.classList.add("age-verification--locked");
    document.body.classList.add("age-verification--locked");
  }

  function unlockScroll() {
    document.documentElement.classList.remove("age-verification--locked");
    document.body.classList.remove("age-verification--locked");
  }

  function trapFocus(modalEl) {
    const selectors = [
      "a[href]",
      "area[href]",
      "button:not([disabled])",
      "input:not([disabled])",
      "select:not([disabled])",
      "textarea:not([disabled])",
      "[tabindex]:not([tabindex='-1'])"
    ].join(",");

    function getFocusable() {
      return Array.from(modalEl.querySelectorAll(selectors)).filter((el) => el.offsetParent !== null);
    }

    function onKeyDown(e) {
      if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      if (e.key !== "Tab") return;

      const focusable = getFocusable();
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first || !modalEl.contains(document.activeElement)) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    document.addEventListener("keydown", onKeyDown, true);
    return () => document.removeEventListener("keydown", onKeyDown, true);
  }

  function showModal(el) {
    el.hidden = false;
    lockScroll();

    const yesButton = el.querySelector("[data-age-action='yes']");
    if (yesButton) yesButton.focus();
  }

  function hideModalWithFade(el) {
    el.classList.add("is-leaving");
    window.setTimeout(() => {
      el.hidden = true;
      el.classList.remove("is-leaving");
      unlockScroll();
    }, 260);
  }

  function verify(days) {
    setCookie(COOKIE_NAME, "1", days);

    const exp = nowInSeconds() + Math.floor(days * 24 * 60 * 60);
    trySetLocalStorage(STORAGE_KEY, JSON.stringify({ v: 1, exp }));
  }

  function setup() {
    const el = document.getElementById("AgeVerification");
    if (!el) return;
    if (el.dataset.initialized === "true") return;
    el.dataset.initialized = "true";

    const days = Number(el.getAttribute("data-cookie-days") || "30") || 30;
    const redirectUrl = el.getAttribute("data-redirect-url") || "https://www.google.com/";

    if (isVerified()) return;

    const teardownFocusTrap = trapFocus(el);
    showModal(el);

    function onClick(e) {
      const target = e.target;
      if (!(target instanceof Element)) return;
      const button = target.closest("[data-age-action]");
      if (!button) return;

      const action = button.getAttribute("data-age-action");
      if (action === "yes") {
        verify(days);
        teardownFocusTrap();
        hideModalWithFade(el);
        return;
      }

      if (action === "no") {
        // Keep blocking interactions; leave overlay visible during redirect.
        window.location.replace(redirectUrl);
      }
    }

    el.addEventListener("click", onClick);

    // Prevent background scroll via wheel/touch when some browsers ignore overflow lock
    function prevent(e) {
      if (!el.hidden) {
        e.preventDefault();
      }
    }
    window.addEventListener("wheel", prevent, { passive: false });
    window.addEventListener("touchmove", prevent, { passive: false });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setup);
  } else {
    setup();
  }
})();
